<template>
  <landing-page
    label="factSheet.cholesteral"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'factsheet', imgName: 'estimatedCholesterolContentChartLandingImage', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
  />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div class="font-bold text-description">{{ t("factSheet.whatIsCholesterol") }}</div>
      <div v-html="t('factSheet.whatIsCholesterolDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.bodyMechanismCholesterol") }}</div>
      <div v-html="t('factSheet.bodyMechanismCholesterolDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.healthEffectsCholesterol") }}</div>
      <div v-html="t('factSheet.healthEffectsCholesterolDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.desirableLevelOfCholesterol") }}</div>
      <div v-html="t('factSheet.desirableLevelOfCholesterolDesc')" class="space-y-5" />
      <table class="table-auto mt-5 w-full border border-black">
        <thead>
          <tr>
            <th class="border border-black">{{ t("factSheet.typesOfBloodCholesterol") }}</th>
            <th>{{ t("factSheet.desirableLevels") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="border border-black px-8 py-5" v-html="t('factSheet.totalCholesterol')" />
            <td class="border border-black px-8 py-5" v-html="t('factSheet.below52')" />
          </tr>
          <tr>
            <td class="border border-black px-8 py-5" v-html="t('factSheet.LDLCholesterol')" />
            <td class="border border-black px-8 py-5" v-html="t('factSheet.below34')" />
          </tr>
          <tr>
            <td class="border border-black px-8 py-5" v-html="t('factSheet.HDLCholesterol')" />
            <td class="border border-black px-8 py-5" v-html="t('factSheet.above10')" />
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div class="font-bold text-description">{{ t("factSheet.preventCholesterol") }}</div>
      <div v-html="t('factSheet.preventCholesterolDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.dietaryAdvices") }}</div>
      <ol class="space-y-12">
        <template v-for="(item, index) in factSheetStore.cholesteralDietaryAdvicesList" :key="'cholesteralDietaryAdvices' + index">
          <li>
            <span v-html="t(item.desc)" />
            <template v-if="item.tableTitle != undefined">
              <table class="table-auto mt-5 w-full border border-black">
                <thead>
                  <tr>
                    <template v-for="(tableTitle, titleIdx) in item.tableTitle" :key="'cholesteralDietaryAdvicesTableTitle' + titleIdx">
                      <th v-html="t(tableTitle)" class="w-1/2 border border-black text-center" />
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(tableContent, contentIdx) in item.tableContent" :key="'cholesteralDietaryAdvicesTableContent' + contentIdx">
                    <tr>
                      <td class="border border-black px-8 py-5">{{ t(tableContent.label) }}</td>
                      <td class="border border-black px-8 py-5">{{ t(tableContent.desc) }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </template>
            <template v-if="item.list != undefined">
              <ul class="list-disc bullet-big">
                <template v-for="(list, listIdx) in item.list" :key="'cholesteralDietaryAdvicesList' + listIdx">
                  <li v-html="t(list)" />
                </template>
              </ul>
            </template>
          </li>
        </template>
      </ol>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.healthyLifestyles") }}</div>
      <ol>
        <template v-for="(item, index) in factSheetStore.cholesteralHealthyLifestyleList" :key="'cholesteralHealthyLifestyle' + index">
          <li v-html="t(item.label)" />
        </template>
      </ol>
    </div>

    <div v-html="t('factSheet.cholesterolRef')" class="space-y-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.cholesteral") }}</div>
      </div>

      <div>
        <div v-html="t('factSheetChinese.whatIsCholesterolDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.bodyMechanismCholesterol") }}</div>
        <div v-html="t('factSheetChinese.bodyMechanismCholesterolDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.healthEffectsCholesterol") }}</div>
        <div v-html="t('factSheetChinese.healthEffectsCholesterolDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.desirableLevelOfCholesterol") }}</div>
        <div v-html="t('factSheetChinese.desirableLevelOfCholesterolDesc')" class="space-y-5" />
        <table class="table-auto mt-5 w-full border border-black">
          <thead>
            <tr>
              <th class="border border-black">{{ t("factSheetChinese.typesOfBloodCholesterol") }}</th>
              <th>{{ t("factSheetChinese.desirableLevels") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="border border-black px-8 py-5" v-html="t('factSheetChinese.totalCholesterol')" />
              <td class="border border-black px-8 py-5" v-html="t('factSheetChinese.below52')" />
            </tr>
            <tr>
              <td class="border border-black px-8 py-5" v-html="t('factSheetChinese.LDLCholesterol')" />
              <td class="border border-black px-8 py-5" v-html="t('factSheetChinese.below34')" />
            </tr>
            <tr>
              <td class="border border-black px-8 py-5" v-html="t('factSheetChinese.HDLCholesterol')" />
              <td class="border border-black px-8 py-5" v-html="t('factSheetChinese.above10')" />
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.preventCholesterol") }}</div>
        <div v-html="t('factSheetChinese.preventCholesterolDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.dietaryAdvices") }}</div>
        <ol class="space-y-12">
          <template v-for="(item, index) in factSheetStore.cholesteralDietaryAdvicesList" :key="'cholesteralDietaryAdvices' + index">
            <li>
              <span v-html="t(item.desc.replace('factSheet', 'factSheetChinese'))" />
              <template v-if="item.tableTitle != undefined">
                <table class="table-auto mt-5 w-full border border-black">
                  <thead>
                    <tr>
                      <template v-for="(tableTitle, titleIdx) in item.tableTitle" :key="'cholesteralDietaryAdvicesTableTitle' + titleIdx">
                        <th v-html="t(tableTitle.replace('factSheet', 'factSheetChinese'))" class="w-1/2 border border-black text-center" />
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(tableContent, contentIdx) in item.tableContent" :key="'cholesteralDietaryAdvicesTableContent' + contentIdx">
                      <tr>
                        <td class="border border-black px-8 py-5">{{ t(tableContent.label.replace("factSheet", "factSheetChinese")) }}</td>
                        <td class="border border-black px-8 py-5">{{ t(tableContent.desc.replace("factSheet", "factSheetChinese")) }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </template>
              <template v-if="item.list != undefined">
                <ul class="list-disc bullet-big">
                  <template v-for="(list, listIdx) in item.list" :key="'cholesteralDietaryAdvicesList' + listIdx">
                    <li v-html="t(list.replace('factSheet', 'factSheetChinese'))" />
                  </template>
                </ul>
              </template>
            </li>
          </template>
        </ol>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.healthyLifestyles") }}</div>
        <ol>
          <template v-for="(item, index) in factSheetStore.cholesteralHealthyLifestyleList" :key="'cholesteralHealthyLifestyle' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ol>
      </div>

      <div v-html="t('factSheetChinese.cholesterolRef')" class="space-y-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>